import { FormProvider, useForm } from "react-hook-form";
import { AnnualProcurementType } from "@type/procurements/annualProcurementPlan";
import { InputTextRow } from "@components";

export const AnnualBudgetPlanDetailsForm = ({
  procurement,
  id,
}: {
  procurement: AnnualProcurementType;
  id: number | string;
}) => {
  const method = useForm({
    values: procurement,
  });
  const { register } = method;

  return (
    <FormProvider {...method}>
      <form>
        <div className="d-flex flex-column gap-8">
          <div className="row">
            <div className="col-lg-12 col-xl-6">
              <InputTextRow
                label="PROCUREMENT_DETAILS.FORM.NAME"
                register={{ ...register("title") }}
                disabled
              />
            </div>
            <div className="col-lg-12 col-xl-6">
              <InputTextRow
                label="PROCUREMENT_DETAILS.FORM.CREATED_DATE"
                register={{ ...register("createdDate") }}
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-xl-6">
              <InputTextRow
                label="PROCUREMENT_DETAILS.FORM.REF_NO"
                register={{ ...register("appRefNo") }}
                disabled
              />
            </div>
            <div className="col-lg-12 col-xl-6">
              <InputTextRow
                label="PROCUREMENT_DETAILS.FORM.YEAR"
                register={{ ...register("financialYear") }}
                disabled
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-xl-6">
              <InputTextRow
                label="PROCUREMENT_DETAILS.FORM.APP_TOTAL_BUDGET"
                register={{ ...register("budget") }}
                disabled
              />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
